import { UITypes } from "types"

import { ReferralStatusCell } from "components/table/columnComponents/ReferralStatusCell"

import { PartnerCell } from "./PartnerCell"
import { ThermostatsCell } from "./ThermostatsCell"

const referralStatusOptions: UITypes.Option[] = [
  { value: "pending_approval", label: "In review" },
  { value: "submitted", label: "Submitted" },
  { value: "in_progress", label: "In progress" },
  { value: "installed", label: "Installed" },
]

export const referralsTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Partner / Customer",
    type: "sort-search",
    size: "large",
    name: "agent_name",
    cellComponent: PartnerCell,
  },
  {
    title: "Realtor email",
    type: "sort-search",
    size: "middle",
    name: "agent_email",
  },
  {
    title: "Address",
    type: "search",
    size: "middle",
    name: "property_address1",
  },
  {
    title: "City",
    type: "default",
    size: "small",
    name: "city",
  },
  {
    title: "State",
    type: "default",
    size: "small",
    name: "state",
  },
  {
    title: "Customer Phone",
    type: "search",
    name: "homeowner_phone",
  },
  {
    title: "Customer Email",
    type: "search",
    name: "homeowner_email",
  },
  {
    title: "Creation date",
    type: "default",
    name: "creation_date",
  },
  {
    title: "Thermostats",
    type: "default",
    size: "small",
    name: "thermostats",
    cellComponent: ThermostatsCell,
  },
  {
    title: "Contractor",
    type: "search",
    size: "middle",
    name: "contractor_name",
  },
  {
    title: "CSM",
    type: "search",
    size: "middle",
    name: "csm_name",
  },
  {
    title: "Internal note",
    type: "search",
    size: "middle",
    name: "internal_note",
  },
  {
    title: "Status",
    type: "select",
    size: "middle",
    name: "status",
    options: referralStatusOptions,
    cellComponent: ReferralStatusCell,
  },
]

export const getReferralsTableHeaderCells = (showArchive: boolean): UITypes.TableHeaderCell[] =>
  showArchive
    ? referralsTableHeaderCells.map(cell =>
        cell.name === "status" ? { ...cell, type: "default", options: undefined } : cell,
      )
    : referralsTableHeaderCells
